module.exports = __webpack_public_path__ + "img/logo.b43ac212.png";